import { FaSearch } from "react-icons/fa";
import styled from "styled-components";

export const ChoosePlanCard = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background-color: #ffffffcc;
    align-items: center;
    justify-content: center;
    padding: 50px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    transition: height 0.3s ease;
    margin-bottom: 200px;

    h1 {
        color: black;
        font-weight: 700;
        font-size: 15px;
        padding-left: 12px;
        margin-bottom: 10px;
        align-self: flex-end;
    }

    h2 {
    color: black;
    font-size: 20px;
    margin-top: 10px;
    }
`;

export const ClearButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 12px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.2s ease;

  &:hover {
    background-color: #c0392b;
  }
`;

export const PlansDropdown = styled.select`
    height: 30px;
    width: 100%;
    background-color: #D0E1EF;
    justify-content: space-between;
    border: none;
    border-width: 2px;
    border-color: transparent;
    border-style: none;
    color: black;
    outline: none;
    border-radius: 60px;
    margin-bottom: 40px;

    &:focus {
    border-color: #5c8e; 
    border-width: 2px;
    outline: none;
    border-width: 0;
    border: none;
  }
`
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  gap: 15px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 90px;

  select{
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 60px;
    padding: 0 10px;
    font-size: 14px;
    outline: none;
    width: 103%;

    &:focus {
      border-color: #E0F1FF;
      border-width: 2px;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  }
`;

export const DocButton = styled.button`
    background-color: white;
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 60px;
    padding: 0 10px;
    font-size: 14px;
    outline: none;
    width: 101.5%;
    cursor: pointer;

    &:focus {
      border-color: #E0F1FF;
      border-width: 2px;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`

export const FormFieldCpf = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 90px;
  width: 70%;
  align-self: center;
`;

interface NewRegisterCardProps {
  isExpanded?: boolean;
}

export const SearchCPFContainer = styled.div<NewRegisterCardProps>`
    position: relative;
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-bottom: ${({ isExpanded }) => (isExpanded ? "50px" : "0")};
`;

export const SearchIcon = styled(FaSearch)`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #005CA9;
    
    cursor: pointer;
`;

export const RemoveButton = styled.button`
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 10px;
  margin-bottom: 10px;
`;


export const SearchCPFBar = styled.input`
    position: relative;
    width: 100%;
    height: 40px;
    background-color: transparent;
    border: 1px solid;
    color: black;
    font-size: 18px;
    font-weight: 500;
    align-self: flex-start;
    padding-left: 9px;
    display: flex;
    justify-content: space-around;
    border-end-end-radius: 20px;
    border-end-start-radius: 20px;
    border-start-end-radius: 20px;
    border-start-start-radius: 20px;
    transition: all 0.3s ease;

    &:focus {
        border: 1px solid #5c8e;
        box-shadow: 0 0 8px rgba(92, 142, 200, 0.5); 
        outline: none; 
    }
`

export const FormRow = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 100px;
`;

export const FormRow2 = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
`;

export const FormLabel = styled.label`
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;

export const FormInput = styled.input`
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 60px;
  padding: 0 10px;
  font-size: 14px;
  outline: none;
  width: 100%;
  margin-bottom: 5px;

  &:focus {
    border-color: #E0F1FF;
    border-width: 2px;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const DependentsButton = styled.button`
  width: 180px;
  padding: 15px;
  margin-right: -20px;
  background-color: #D0E1EF;
  color: #005CA9;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  border: none;
  border-radius: 60px;
  cursor: pointer;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
`
interface ChoosePlanCardProps {
  isExpanded?: boolean;
}

export const ConfirmButton = styled.button<ChoosePlanCardProps>`
    background-color: #FF5641;
    display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
    justify-content: center;
    align-items: center;
    width: 200px;
    padding: 10px;
    border: none;
    border-radius: 50px / 40px;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    position: absolute;
    bottom: 180px; 
    right: 70px; 
`